import React from "react"
import * as styles from "./hero.module.scss"
import * as caseStyle from "../cases/cases.module.scss"
import parse from "html-react-parser"
import Breadcrumbs from "../breadcrumbs/Breadcrumbs";

const CaseHero = ({content, desc, pageTitle, cats, tags}) => {
    if (!content) {
        return false;
    }

    let description = '';
    if (desc !== null) {
        description = parse(desc);
    }
    const title = parse(`<small>${content.companyname}</small><br>${content.casetitle}`);

    const breadcrumbs = [
        {
            "uri": "/cases/",
            "title": "Cases"
        }
    ]
    return (
        <section className={`${styles.hero} ${styles.heroSm} ${caseStyle.caseHero}`}>
            <div className="grid-container-wrap">
                <div className="grid-container">
                    <div
                        className="grid-colstart-2-xl-min grid-colend-8-xl-min grid-col-8-xl-md grid-col-9-md-sm grid-col-10-sm-xs">
                        <Breadcrumbs breadcrumbs={breadcrumbs} pageTitle={pageTitle}/>
                    </div>

                    <div
                        className="grid-colstart-2-xl-min grid-colend-7-xl-min grid-col-7-xl-md grid-col-7-md-sm grid-col-9-sm-xs">
                        <h1 className={styles.heroTitle}>{title}</h1>
                        {description}
                    </div>
                    <div
                        className="grid-colstart-8-md-min grid-colend-13-md-min grid-col-5-md-sm grid-col-9-sm-xs ai-center-md-min ai-end-md-sm flex-sm-min">
                        <table className={caseStyle.caseHeroTable}>
                            {content.companyname &&
                            <tr>
                                <th>opdrachtgever</th>
                                <td>{content.companyname}</td>
                            </tr>
                            }
                            {cats &&
                            <tr>
                                <th>sector</th>
                                <td>
                                    {
                                        cats.map((category, key) => {
                                            return <span key={key}>{category.name}</span>
                                        }).reduce((acc, x) =>
                                            acc === null ?
                                                [x]
                                                : [acc, ', ', x], null
                                        )
                                    }
                                </td>
                            </tr>
                            }
                            {content.cooperation &&
                            <tr>
                                <th>samenwerking</th>
                                <td>{content.cooperation}</td>
                            </tr>
                            }
                            {content.assignment &&
                            <tr>
                                <th>opdracht</th>
                                <td>{content.assignment}</td>
                            </tr>
                            }
                            {content.website &&
                            <tr>
                                <th>website</th>
                                <td><a target="_blank" rel="noopener noreferrer" href={`https://${content.website}`}>{content.website}</a></td>
                            </tr>
                            }
                        </table>
                    </div>

                    {tags.length > 0 &&
                    <div
                        className="grid-colstart-2-xl-min grid-colend-7-xl-min grid-col-7-xl-md grid-col-7-md-sm grid-col-9-sm-xs">
                        <ol className={caseStyle.casesTagsList}>
                            {tags.map((tag, tagKey) => {
                                return <li key={`${tag.slug}-${tagKey + 1}`}><a
                                    href={`/cases/${tag.slug}`}>{tag.name}</a></li>;
                            })}
                        </ol>
                    </div>
                    }

                </div>
            </div>
        </section>
    )
}

export default CaseHero